import { FormTextBox, IDynamicFormRow } from '@src/components';
import { isValidEmail } from '@src/utilities/validation';

type ResetPasswordSchemaProps = {
    t: (key: string, options?: Record<string, any>) => string;
};

export function resetPasswordSchema({
    t,
}: ResetPasswordSchemaProps): IDynamicFormRow[] {
    return [
        {
            label: '',
            keyName: 'email',
            inputProperties: {
                placeholder: 'Email',
                type: 'email',
            },
            className: 'h-12',
            Component: FormTextBox,
            registerOptions: {
                required: {
                    value: true,
                    message: t('errors.formErrors.required', {
                        name: t('forms.email'),
                    }),
                },
                validate: (email) => {
                    if (!isValidEmail(email))
                        return t('errors.formErrors.email');
                    return true;
                },
            },
        },
    ];
}
